module.exports = __webpack_public_path__ + "static/media/twa_sat_cropped.596b5a63.webp";